var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__registers"},[_c('ContentHeader',[_c('SubHeader',{attrs:{"title":_vm.title}})],1),_c('ContentBody',[_c('Card',[_c('router-view',{on:{"atualizarTitulo":_vm.atualizaTitulo}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }